import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addPropertyData: [],
};

export const AddPropertyDataSlice = createSlice({
  name: "addPropertyData",
  initialState,
  reducers: {
    getAddPropertyDataAction: (state, action) => {
      state.addPropertyData = action.payload;
    },
  },
});

export default AddPropertyDataSlice.reducer;

export const { getAddPropertyDataAction } = AddPropertyDataSlice.actions;
